/**
 * Card Hover Image Cycle
 * Cycles through product images based on mouse horizontal position
 */
(function () {
  function initHoverCycle() {
    const cards = document.querySelectorAll('.card-product--image-swipe-container');

    cards.forEach(function (container) {
      const track = container.querySelector('.card-product--image-swipe-track');
      const slides = container.querySelectorAll('.card-product--image-slide');
      const bullets = container.closest('.card-product')
        ? container.closest('.card-product').querySelectorAll('.product-card--pagination-bullet')
        : [];

      if (!track || slides.length < 2) return;

      let lastIndex = -1;

      function goToSlide(index) {
        if (index === lastIndex) return;
        lastIndex = index;

        const slideWidth = track.offsetWidth;
        track.scrollTo({ left: slideWidth * index, behavior: 'smooth' });

        bullets.forEach(function (b, i) {
          b.classList.toggle('active', i === index);
        });
      }

      container.addEventListener('mousemove', function (e) {
        const rect = container.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const ratio = x / rect.width;
        const index = Math.min(Math.floor(ratio * slides.length), slides.length - 1);
        goToSlide(index);
      });

      container.addEventListener('mouseleave', function () {
        lastIndex = -1;
        track.scrollTo({ left: 0, behavior: 'smooth' });

        bullets.forEach(function (b, i) {
          b.classList.toggle('active', i === 0);
        });
      });
    });
  }

  // Init on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHoverCycle);
  } else {
    initHoverCycle();
  }

  // Re-init after infinite scroll / pagination loads new cards
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.addedNodes.length) {
        initHoverCycle();
      }
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();
